export enum AuthTokenType {
    BEARER = 'Bearer'
}
